import type { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  /** Lucide icon or other decorative React node. */
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  /** Primary CTA — typically a <Button>. */
  action?: ReactNode;
  /** Compact variant — smaller spacing, inline-friendly. */
  compact?: boolean;
  className?: string;
}

/**
 * Empty state placeholder per §7.3.
 *
 * Used for: integrator users with no clients yet, lists with active filters
 * returning nothing, fresh-install lists. Pair `description` with an
 * explanation of when the section will fill ("Clients appear here once the
 * manufacturer books one to your integrator.")
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  compact,
  className,
}: EmptyStateProps) {
  return (
    <div className={clsx(styles.root, compact && styles.compact, className)}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <h3 className={styles.title}>{title}</h3>
      {description && <p className={styles.description}>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
